import React from 'react'

function Segment() {
  return (
    <div>Segment</div>
  )
}

export default Segment